import { AcornsIcon } from '@acorns/icons'
import { Bodytext, Button, Heading, Tabs } from '@acorns/web-components'
import styled from 'styled-components'

import { StatsBar } from 'components/StatsBar'
import { style } from 'theme'

export const Relative = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const StyledLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 800px;
  height: 500px;
  width: 100%;
`

export const StyledTabs = styled(Tabs)<{
  isDescriptionDisplayed?: boolean
}>`
  width: 100%;
  padding: 0px;
  margin-top: ${(props) => (props.isDescriptionDisplayed ? '30px' : '50px')};
`

export const MinimalRelativeContainer = styled.div<{
  isHeaderBelowGraph?: boolean
}>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  top: ${(props) => (props.isHeaderBelowGraph ? 37 : 0)}px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    background: ${(props) => props.theme.colors.white};
    top: 0;
  }
`

export const RecommendedRiskContainer = styled.div`
  display: flex;
  background: ${style((theme) => theme.colors.ivoryLight)};
  width: 100%;
  border-radius: ${style((theme) => theme.borderRadius.large)};
  padding: 20px;
  margin-bottom: 50px;
`

export const RecommendedRiskBody = styled(Bodytext)`
  font-size: 14px;
  line-height: 22px;
  margin-left: 10px;
  width: fit-content;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 225px;
  }
  @media (max-width: 350px) {
    width: 150px;
  }
`

export const RecommendedRiskContentContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const RecommendedRiskButtonContainer = styled.button`
  display: flex;
  font-size: 14px;
  font-weight: 600;
  margin-left: 5px;
  margin-top: 5px;
  border: none;
  background: none;
  cursor: pointer;
  color: ${style((theme) => theme.colors.green)};
`

export const StyledChevronRight = styled(AcornsIcon)`
  margin-left: 8px;
  margin-top: 2px;
  path {
    &[fill] {
      stroke: ${(props) => props.theme.colors.green} !important;
    }
  }
`

// Leaving here for now until we add disclosure text when backend is ready
export const DisclosureText = styled(Bodytext)`
  font-size: 12px;
  line-height: 16px;
  color: ${style((theme) => theme.colors.stone)};
  padding-top: 80px;
  padding-right: 50px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding-right: 0px;
  }
`

export const StyledLink = styled.a`
  font-size: 12px;
  line-height: 22px;
  color: ${style((theme) => theme.colors.stone)};
`

export const StyledHr = styled.hr`
  position: absolute;
  left: 0;
  max-width: 800px;
  width: 100%;
  margin-top: 30px;
  box-sizing: border-box;
  border: 5px solid ${style((theme) => theme.colors.ivoryLight)};
`

export const ConsiderationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    margin-bottom: 0px;
  }
`

export const ConsiderationsHeading = styled(Bodytext)`
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
`

export const ConsiderationsIconTextContainer = styled.div`
  display: flex;
  margin-top: 15px;
`

export const StyledCheckmark = styled(AcornsIcon)`
  margin-top: 5px;
  margin-right: 10px;
  path {
    &[fill] {
      stroke: ${(props) => props.theme.colors.green} !important;
    }
  }
`

export const ConsiderationsRiskBarContainer = styled.div`
  width: 500px;
  margin-bottom: 33px;
  @media (max-width: 605px) {
    width: 100%;
  }
`
export const ConsiderationsRiskBarHeader = styled(Heading)`
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
`

export const StyledStatsBar = styled(StatsBar)`
  @media screen and (min-width: ${style(
      (theme) => theme.breakpoints.sm + 1,
    )}px) {
    max-width: 450px;
  }
`

export const StyledBodytext = styled(Bodytext)`
  max-width: 450px;
  text-align: center;
`

export const DoughnutContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    background: ${(props) => props.theme.colors.white};
  }
`

export const ContentContainer = styled.div<{ hasCustomContent?: boolean }>`
  background-color: ${style((theme) => theme.colors.white)};
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(props) =>
    !props.hasCustomContent &&
    `
    padding: 40px 0 30px;
  `}

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const StartCustomizingButton = styled(Button)`
  width: 200px;
  margin: 20px 0px 90px;
  padding: 10px 24px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 600;
  background: linear-gradient(90.54deg, #c5fc9c -8.38%, #164a8a 113.95%);

  &:hover {
    background: linear-gradient(90.54deg, #c5fc9c -8.38%, #164a8a 113.95%);
  }
`

export const DoughnutText = styled(Bodytext)`
  width: 130px;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: ${style((theme) => theme.colors.stone)};
`

export const StyledArrowRight = styled(AcornsIcon)`
  margin-left: 14px;
  path {
    fill: ${style((theme) => theme.colors.white)};
  }
  path {
    &[stroke] {
      stroke: ${(props) => props.theme.colors.white};
    }
  }
`

export const ListContainer = styled.div<{ showGrid?: boolean }>`
  background-color: ${style((theme) => theme.colors.white)};
  display: flex;
  flex-direction: column;
  align-items: center;

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    ${(props) => props.showGrid && 'margin-top: 10px;'}
    margin-bottom: unset;
  }
`

export const ContentStatsContainer = styled.div`
  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    width: 100%;
    padding: 0 30px;
    margin: 10px 0 50px;
  }
`

export const GridContainer = styled.div`
  width: 100%;
`

export const StatTooltipContent = styled.div`
  text-align: center;
`

export const PassionsCustomizeContainer = styled.div`
  width: 100%;
  background-color: ${style((theme) => theme.colors.white)};

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding: 0 30px;
  }

  @media (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    padding-bottom: 50px;
  }
`
